import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { isKDSMode } from "../../common/util";
import Orders from "./Orders";

export default function OrderDashboard(props) {
  const { user } = useContext(UserContext);
  const location = useLocation();

  if (isKDSMode(user)) {
    return <Navigate replace to={`/production/tracker${location.search}`} />;
  } else if (user.role === "baker" || user.role === "owner") {
    return <Orders />;
  } else if (user.role === "rep" || user.role === "manager") {
    return <Orders />;
  } else if (user.role === "clerk") {
    return <Orders />;
  }
}
